export const TripPlanningComponentName: string = 'tripPlanning';
